import { render } from "./updateCustomer.vue?vue&type=template&id=4df92518&scoped=true"
import script from "./updateCustomer.vue?vue&type=script&lang=js"
export * from "./updateCustomer.vue?vue&type=script&lang=js"

import "./updateCustomer.vue?vue&type=style&index=0&id=4df92518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df92518"]])

export default __exports__